import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { NavLink } from "react-router-dom";
import { isEmpty } from "underscore";
import styled from "styled-components";
import {
  Bar,
  SearchInput,
  Button,
  ListboxMultiselect,
  Icon,
} from "@evertrue/et-components";
import Api from "utils/api";

const ImportFilters = ({
  onSearch,
  searchValue,
  activeFilters = {},
  onFilterClear = () => {},
  onStatusFilterChange = () => {},
}) => {
  const [statusFilterOptions, setStatusFilterOptions] = useState([]);

  useEffect(() => {
    const fetchStatusOptions = async () => {
      try {
        const response = await Api.IMPORT.JOB_STATUS_GROUPS.get();
        if (response.status !== 200) {
          throw new Error("Failed to fetch status options");
        }
        const { data } = response;
        const options = Object.entries(data).map(([key, value]) => ({
          label: key,
          value: value,
        }));
        setStatusFilterOptions(options);
      } catch (error) {
        console.error("Error fetching status options:", error);
      }
    };

    fetchStatusOptions();
  }, []);

  return (
    <React.Fragment>
      <Bar
        left={
          <FilterContainer>
            <SearchInput
              width="350px"
              debounceTimeout={300}
              value={searchValue}
              className={"import-filters--search-box"}
              placeholder="Search by file name..."
              onChange={onSearch}
            />
            {statusFilterOptions.length ? (
              <FilterContainer style={{ marginLeft: "8px" }}>
                <ListboxMultiselect
                  label="Status"
                  size="medium"
                  options={statusFilterOptions}
                  onChange={onStatusFilterChange}
                  values={activeFilters.status || []}
                  placeholder="Status"
                />
                {!isEmpty(activeFilters) &&
                activeFilters.status &&
                activeFilters.status.length ? (
                  <div style={{ marginLeft: "8px" }}>
                    <Button type="simple" onClick={onFilterClear}>
                      <Icon icon="clear" />
                      Reset All
                    </Button>
                  </div>
                ) : null}
              </FilterContainer>
            ) : null}
          </FilterContainer>
        }
        right={
          <NavLink to="/importer/import-upload">
            <Button type="action">New Import</Button>
          </NavLink>
        }
      />
    </React.Fragment>
  );
};

ImportFilters.propTypes = {
  onSearch: PropTypes.func.isRequired,
  searchValue: PropTypes.string.isRequired,
  activeFilters: PropTypes.object.isRequired,
  onFilterClear: PropTypes.func.isRequired,
  onStatusFilterChange: PropTypes.func.isRequired,
};

const FilterContainer = styled.div`
  display: flex;
  align-items: center;
`;

export default ImportFilters;
